// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"277": "versions","574": "version",}[chunkId] || chunkId) + "." + {"237": "65f27fdd5c1baaae","277": "29255a05552f3200","367": "f3e4b146049aa9c3","547": "e0a6900d59d168a9","574": "6c697f0631f4484a",}[chunkId] + ".js"
}